import FrontMain from "components/Layout/FrontMain";
import LoginImage from "components/Layout/LoginImage";
import { PropsWithChildren, Suspense } from "react";
import { RouterContext } from "utils/RouterManager/RouterManager";
import "./AuthPage.scss";

interface AuthPageProps {
    prevUrl: string;
}

const AuthPage = ({ prevUrl, children }: PropsWithChildren<AuthPageProps>) => {
    return (
        <Suspense fallback={<></>}>
            <RouterContext.Provider value={{ prevUrl }}>
                <LoginImage />
                <FrontMain>{children}</FrontMain>
                <a
                    href="https://cloudomation.com/imprint/"
                    target="_blank"
                    rel="noreferrer"
                    className="imprintLink"
                >
                    Imprint
                </a>
            </RouterContext.Provider>
        </Suspense>
    );
};

export default AuthPage;
